import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type SendEnrollmentsToHostFamilyRequest = {
  centerId: number
  ids: number[]
}

export async function sendEnrollmentsToHostFamily(input: SendEnrollmentsToHostFamilyRequest) {
  const { centerId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.centers.sendEnrollmentsToHostFamily.url, { id: centerId }))
    .post(rest)
}
